import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-78" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border-2 border-volt bg-graphite px-3 py-2.5" data-id="element-79" data-mp="1o3dnadhb4fro">
        <ShieldCheckIcon className="mt-0.5 h-9 w-9 shrink-0 text-volt" strokeWidth={1.6} aria-hidden="true" data-id="element-80" data-mp="1x4bsgz3hetbu" />
        <div data-id="element-81" data-mp="19ehh6lyt9ctp">
          <h2 className="font-display text-[1.2rem] font-bold uppercase leading-none text-white sm:text-[1.6rem]" data-id="element-82" data-mp="19e7pmty4axlw">
            YOUR PURCHASE IS <span className="text-volt" data-id="element-83" data-mp="14h8x2fu3qypt">100% PROTECTED</span>
          </h2>
          <p className="mt-1 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-84" data-mp="1j4twnzrrqfsz">
            Explore GENERATOR DIAGNOSTIC PRO™ for 7 days. Access the complete 6-module diagnostic
            system and all 5 strategic bonuses. If it isn't right for you, contact us within 7 days
            for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}